import styled from "styled-components";
import { backgroundColors, breakpoints } from "@authentic/loyalty-pwa/util/variables";
import { Box } from "@authentic/loyalty-pwa/util/Box";

export const ChangePasswordPageStyled = styled.div`
  background: ${backgroundColors.lightGray};
  max-width: 552px;
  form label {
    font-family: 'Nunito Sans';
  }

  margin: 36px auto;
  background-color: white;
  @media screen and (max-width: ${breakpoints.md}) {
    margin: 0 auto;
  }
`;

export const ChangePasswordContentStyled = styled.div`
  background: ${backgroundColors.white};
  text-align: center;
  margin: 0 auto;
  max-width: 550px;
  @media screen and (min-width: ${breakpoints.sm}) {
    
  }
`;

export const FormStyled = styled.form`
  background: #ffffff;
  text-align: left;
  padding: 36px;
`;

export const FormHint = styled.div`
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 11px;
  text-align: right;
`;

export const FormControlStyled = styled(Box)`
`;

export const FormTitleStyled = styled.div`
  background-color: #E7E7E7;
  position: relative;
  height: 63px;
  span {
    font-family: Nunito Sans;
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 63px;
    display: block;
    text-align: center;
    letter-spacing: 0.03em;
    text-transform: uppercase;
  }

  svg {
    position: absolute;
    top: 20px;
    left: 36px;
    cursor: pointer;
  }
`;

export const SignInButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  a {
    width: 100%;
    
  }
  button {
    cursor: pointer;
  }
  a:nth-child(1) {
    margin-right: 6px;
  }

  @media screen and (max-width: ${breakpoints.sm} ) {
    display: block;
  }
`;